





































import { isObject } from "@szgc/plt-core-v2";
import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "BooleanWidget",
  components: { MagicValidator }
})
export default class BooleanWidget extends WidgetBase implements App.PuttedWidgetComponent {
  setValue(value: string) {
    if (value) {
      this.value = value === "true" || value === "false" ? value === "true" : null;
    }
  }

  mounted() {
    /*if (this.status === "mine") {
      this.value = !!(
        "" +
        (isObject(this.defaultValue)
          ? this.defaultValue.value
          : this.defaultValue)
      ).toString();
    }*/
    if (this.status === "mine") {
      if (isObject(this.widget.defaultValue)) {
        if ((this.widget.defaultValue as any).value) {
          this.value = (this.widget.defaultValue as any).value === "true";
          // this.value =  !!(
          //   "" + (this.widget.defaultValue as any).value
          // ).toString();
        } else {
          this.value = this.widget.value === "true";
          // this.value =  !!(
          //   "" + this.widget.value
          // ).toString();
        }
      }
      if (this.widget.value) {
        this.value = this.widget.value === "true";
        // this.value = !!(
        //   "" + this.widget.value
        // ).toString();
      }
    } else {
      this.value = this.widget.value === "true";
      // this.value = !!(
      //   "" + this.widget.value
      // ).toString();
    }
  }
}
